import { TranslationKey } from "@/common/hooks/useTranslate";

const DELETE_ERROR_KEY_BY_CODE: Partial<Record<string, TranslationKey<"dashboard">>> = {
  contact_list_not_found: "crm.lists.notFound",
  contact_list_has_newsletter_form: "crm.lists.deleteErrorHasNewsletterForm",
  contact_list_is_default_communication_preference: "crm.lists.deleteErrorDefaultCommunicationPreference",
};

export const getDeleteContactListErrorKey = (code: string | undefined): TranslationKey<"dashboard"> =>
  (code && DELETE_ERROR_KEY_BY_CODE[code]) || "crm.lists.deleteError";
